export const FormerlyKnownAsTwitterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect width="32" height="32" rx="16" fill="#EAECF1" fillOpacity="0.5" />
    <path
      d="M17.8308 14.922L23.033 9H21.8004L17.2813 14.1409L13.6746 9H9.51367L14.969 16.7747L9.51367 22.9842H10.7463L15.5156 17.554L19.3253 22.9842H23.4863L17.8308 14.922ZM16.1421 16.8429L15.5885 16.0682L11.1908 9.91H13.0843L16.6344 14.8817L17.1857 15.6564L21.7998 22.1186H19.9063L16.1421 16.8429Z"
      fill="#383D48"
    />
  </svg>
)
